import { render, staticRenderFns } from "./BulkCategorySelector.vue?vue&type=template&id=ba4e71cc"
import script from "./BulkCategorySelector.vue?vue&type=script&lang=js"
export * from "./BulkCategorySelector.vue?vue&type=script&lang=js"
import style0 from "./BulkCategorySelector.vue?vue&type=style&index=0&id=ba4e71cc&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports